import * as React from 'react';
import {Button} from 'src/Button';
import {destructiveOutlineClass} from 'src/DetailComponents';
import {useModals} from 'src/Modals';
import type {DetailTransactionFragment} from '@transactions/graphql';

type Props = {
  transaction: DetailTransactionFragment;
  /** Called after the transaction is reset (e.g. to navigate away). */
  onReset?: () => void;
};

/**
 * The header actions both transaction detail views share, mirroring the raw
 * transaction page: Edit opens the fields in a modal over the read-only
 * display, and the destructive action sits beside it, outlined rather than
 * filled so it never outshouts Edit. Reset is a transaction's
 * delete — it removes the transaction and returns its raw transactions to the
 * inbox — and the modal it opens says exactly that before anything happens.
 */
export const DetailActions = ({transaction, onReset}: Props) => {
  const modals = useModals();

  return (
    <div className="flex items-center gap-3">
      <Button
        variant="outline"
        onClick={() =>
          modals.editTransactionModal.openModal({transaction})
        }
      >
        Edit
      </Button>
      <Button
        variant="outline"
        className={destructiveOutlineClass}
        title="Delete this transaction and return its raw transactions to the inbox"
        onClick={() =>
          modals.resetTransactionModal.openModal({
            transactionId: transaction._id,
            onReset,
          })
        }
      >
        Reset
      </Button>
    </div>
  );
};
